export default "__VITE_ASSET__DwCK8Tbs__"